var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB4RemainingTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 17h3v-4H19v4h3v8.56L31.56 38 22 51.55V59h-3v4h38v-4h-3v-7.45L44.45 38.1 54 25.56V17zm-4 7.24L40 37.18v1.65l10 14V59H26v-6.18l10-14v-1.7L26 24.18V17h24v7.24zm-12 25.7c4.07 0 8 3.49 8 3.49V56H30v-2.57s3.89-3.49 8-3.49zM38 33l-8-11v-2h16v2l-8 11z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B4_Remaining_time.dfd66a2d.svg";
export { SvgB4RemainingTime as ReactComponent };